import React from 'react';
import { IonButtons, IonContent, IonHeader, IonPage, IonTitle, IonToolbar } from '@ionic/react';

import { Plan } from 'components/setting/Plan';
import { BackButton } from 'components/common/buttons/BackButton';

import { withLogin } from 'pages/hocs/withLogin';

export const SettingPlanPage: React.FC = withLogin(() => {
  return (
    <IonPage>
      <IonHeader mode="ios">
        <IonToolbar mode="ios">
          <IonButtons className="header">
            <BackButton defaultHref="/setting" />
          </IonButtons>
          <IonTitle>プラン</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <Plan />
      </IonContent>
    </IonPage>
  );
});
